// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3lq5N","content":"LayoutSettings_content__2CrtE"};